import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import References from './pages/References';
import Services from './pages/Services';

import {
  Routes,
  Route,
} from "react-router-dom";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="/om-oss" Component={About} />
        <Route path="/referenser" Component={References} />
        <Route path="/tjänster" Component={Services} />
        <Route path="/kontakt" Component={Contact} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;